/**
 * Created by zixiong on 2019/3/20
 */
import axios from "./index"
import qs from 'qs';

const baseReq = axios.create({
    baseURL: '',
    timeout: 100000
});

export const getAgentInfo = () => {
    return baseReq
        .get("/platform/agent/api/v1/me", {
        })
        .then(res => {
            if (res.data.code === 200) {
                return res.data.data;
            } else {
                return null;
            }
        });
};

export const getCustomers = (offset, limit) => {
    return baseReq
        .get("/platform/agent/api/v1/customers", {
            params: {
                offset: offset,
                limit: limit
            }
        })
        .then(res => {
            if (res.data.code === 200) {
                return res.data.data;
            } else {
                return null;
            }
        });
};

export const getConsumeRecord = (offset, limit) => {
    return baseReq
        .get("/platform/agent/api/v1/consumes", {
            params: {
                offset: offset,
                limit: limit
            }
        })
        .then(res => {
            if (res.data.code === 200) {
                return res.data.data;
            } else {
                return null;
            }
        }).then();
};

export const openBusinessCheck = (packageType, phoneNo, siteId, appId, shopId) => {
    const data = {
                openBusinessType: packageType,
                phoneNo: phoneNo,
                siteId: siteId,
                appId: appId,
                shopId: shopId
            };
    return baseReq
        .post("/platform/agent/api/v1/businessOpenCheck",
            qs.stringify(data),
            {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        )
        .then(res => {
            return res.data;
        })
        .catch(err => console.log(err));
};

export const openBusiness = (packageType, phoneNo, siteId, appId, shopId) => {
    const data = {
        openBusinessType: packageType,
        phoneNo: phoneNo,
        siteId: siteId,
        appId: appId,
        shopId: shopId
    };
    return baseReq
        .post("/platform/agent/api/v1/businessPackages",
            qs.stringify(data),
            {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        )
        .then(res => {
            if (res.data.code === 200) {
                return res.data.data;
            } else {
                return null;
            }
        })
        .catch(err => console.log(err));
};
